<!--  -->
<template>
    <div class="get_coupon" :class="{'show': show}">
        <div class="cover" @click="show = false"></div>
        <div class="content">
            <div class="title">优惠券</div>
            <img class="close" @click="close" :src="require('@/common/images/course/close.png')" alt="">
            <div class="list">
                <div class="item" v-for="(item, index) in list" :key="index">
                    <div class="left">
                        <div class="value_box">
                            <div class="value" v-if="item.voucherdistype === 1">
                                <span class="unit">￥</span>
                                <span class="faceprice">{{item.faceprice}}</span>
                                <span class="userule" v-if="!item.userule">满{{item.minordermoney}}元使用</span>
                                <span class="userule" v-else>无门槛</span>
                            </div>
                            <div class="value" v-if="item.voucherdistype === 2">
                                <span class="faceprice">{{item.voucherdisrate}}</span>
                                <span class="unit">折</span>
                                <span class="userule" v-if="!item.userule">满{{item.minordermoney}}元使用</span>
                                <span class="userule" v-else>无门槛</span>
                            </div>
                        </div>
                        <div class="datetime" v-if="item.datetime !== '-'">
                            有效期：{{item.datetime}}
                        </div>
                        <div class="usescopetypename">{{item.usescopetypename}}</div>
                    </div>
                    <div class="right">
                        <div v-if="item.isstock === 1">
                            <van-button class="get" @click="getCouponMethod(item)" v-if="item.couponcount === 0">点击领取</van-button>
                            <van-button class="get" @click="getCouponMethod(item)" v-if="(item.countbyper === 0 || item.couponcount < item.countbyper) && item.couponcount > 0">继续领取</van-button>
                        </div>
                        <!-- <van-button></van-button> -->
                    </div>
                    <!-- <div class="geted" v-if="item.couponcount > 0">已领取</div> -->
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
import {getCouponVoucherList, getReceiveCouponVoucher} from 'api/api'
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            show: false,
            list: [],
            courseData: {}
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        open(courseData) {
            this.courseData = courseData
            if (!this.list.length) {
                this.getCouponVoucherList()
            } else {
                this.show = true
            }
        },
        close() {
            this.show = false
        },
        getCouponVoucherList() {
            console.log(this.courseData)
            this.setLoading(true)
            getCouponVoucherList({
                data: {kmcid: this.courseData.kmcid, kmctype: this.courseData.kmctype, page: 0, pageSize: 0},
                success: res => {
                    this.show = true
                    console.log(res)
                    this.list = res.data.content
                    this.setLoading(false)
                },
                error: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        getCouponMethod(item) {
            this.setLoading(true)
            const params = {
                couponinnerid: item.couponvoucherid
            }
            getReceiveCouponVoucher({
                data: params,
                success: res => {
                    this.setLoading(false)
                    this.$toast('领取成功')
                    item.inventory = res.data.inventory
                    ++item.couponcount
                },
                errir: res => {
                    this.setLoading(false)
                    this.$toast.fail(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
    .get_coupon {
        width: 100%;
        height: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.3);
        opacity: 0;
        transition: opacity 0.3s;
        transform: translate3d(0, 100%, 0);
        z-index: 10;
        &.show {
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
        .cover {
            height: 100%;
        }
        .content {
            height: 7.6rem;
            background: #fff;
            border-radius: 0.25rem 0.25rem 0 0;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0 0.32rem;
            box-sizing: border-box;
            .title {
                text-align: center;
                font-size: 0.32rem;
                font-weight: bold;
                line-height: 0.32rem;
                padding: 0.32rem 0.32rem;
            }
            .close {
                width: 0.4rem;
                height: 0.4rem;
                position: absolute;
                top: 0.28rem;
                right: 0.24rem;
            }
            .list {
                flex: 1;
                overflow: scroll;
                padding-top: 0.08rem;
                .item {
                    background: #FEF6EF;
                    padding: 0.1rem 0.24rem 0.12rem;
                    margin-bottom: 0.2rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    position: relative;
                    .left {
                        .value_box {
                            color: #FE666D;
                            .value {
                                margin-bottom: 0.12rem;
                                .unit {
                                    font-size: 0.3rem;
                                }
                                .faceprice {
                                    font-size: 0.52rem;
                                    line-height: 0.72rem;
                                    // font-weight: bold;
                                }
                                .userule {
                                    font-size: 0.28rem;
                                    color: #FE666D;
                                    margin-left: 0.1rem;
                                }
                            }
                        }
                        .datetime {
                            font-size: 0.2rem;
                            color: #9DA4AF;
                            margin-bottom: 0.04rem;
                            line-height: 0.28rem;
                        }
                        .usescopetypename {
                            font-size: 0.2rem;
                            color: #9DA4AF;
                            line-height: 0.28rem;
                        }
                    }
                    .right {
                        .get {
                            width: 1.6rem;
                            height: 0.4rem;
                            background: #FE666D;
                            border-radius: 0.3rem;
                            color: #fff;
                            font-size: 0.24rem;
                            line-height: 0.4rem;
                            padding: 0;
                        }
                    }
                    .geted {
                        width: 1.12rem;
                        height: 0.36rem;
                        background: #FEE4E5;
                        color: #FE666D;
                        font-size: 0.24rem;
                        padding: 0.02rem 0.2rem;
                        text-align: center;
                        line-height: 0.36rem;
                        position: absolute;
                        top: 0;
                        right: 0;
                        border-radius: 0 0.1rem 0 0.1rem;
                    }
                }
            }
        }
    }
</style>